/* eslint no-undef: 0 */
import FetcherFactory from '../../fetcher/Fetchers/factory.js'
import {PageErrorsFactory} from '../Errors/factory.js'
import PageValueObjectsFactory from '../ValueObjects/factory.js'
import {ClientPageRepository} from './ClientPageRepository.js'
import {EmptyPageRepository} from './EmptyPageRepository.js'
import {HTTPPageRepository} from './HTTPPageRepository.js'

export class PageRepositoriesFactory {
  /**
   * @method
   * @return {ClientPageRepository}
   * @property {Function} urlValueObjectFactory
   */
  static clientPageRepository = () =>
    new ClientPageRepository({
      urlValueObjectFactory: PageValueObjectsFactory.urlValueObject
    })

  /**
   * @return {EmptyPageRepository}
   */
  static emptyPageRepository = () =>
    new EmptyPageRepository({
      urlValueObjectFactory: PageValueObjectsFactory.urlValueObject
    })

  /**
   * @return {HTTPPageRepository}
   */
  static hTTPPageRepository = ({config}) =>
    new HTTPPageRepository({
      config,
      fetchOrFail: FetcherFactory.fetchOrFail({config}),
      getRemoteUrlErrorFactory: PageErrorsFactory.getRemoteUrlError,
      urlValueObjectFactory: PageValueObjectsFactory.urlValueObject
    })
}
